import Flickity from 'flickity'
import { eventBus } from '@/main'
import mixins from '@/mixins'
require('waypoints/lib/noframework.waypoints')

export const MyTabs = {
  name: 'my-tabs',
  template: `
    <div class="o-tabs">
      <div class="o-tab__wrapper">
        <div class="o-tab__menu" tabindex="0" ref="flkty">
          <div class="o-tab__item" v-for="(tab, index) in tabs" :class="[{'o-tab__item--active': currentIndex === index}, tab.colorClass('o-tab__item--', tab.tabColor)]" @click="changeTab(index)">
            <div class="o-tab__item__inner">{{ tab.title }}</div>
          </div>
        </div>
      </div>
      <div class="o-tab__content">
        <slot></slot>
      </div>
    </div>
  `,
  props: {
    initialIndex: {
      required: false,
      type: Number,
      default: 0
    }
  },
  mixins: [mixins],
  data () {
    return {
      tabs: [],
      currentIndex: 0,
      flkty: null,
      elemWidth: 0
    }
  },
  computed: {
    device () {
      return this.$store.state.device
    }
  },
  methods: {
    addTab (tab) {
      this.tabs.push(tab)
      let index = this.tabs.indexOf(tab)
      if (index === this.currentIndex) {
        this.current = tab
        this.tabs[this.currentIndex].active = true
      }
    },
    changeTab (index) {
      this.scrollToSection(null, () => {
        this.$emit('tab-changed', index)
        this.currentIndex = index
        if (this.flkty) {
          this.flkty.select(this.currentIndex, false, false)
        } else {
          this.setActiveTab()
        }
        window.gtag('event', 'tab_clicked', { 'event_label': this.tabs[index].title })
      })
    },
    setActiveTab () {
      for (let value of this.tabs) {
        value.active = value === this.tabs[this.currentIndex]
      }
      Waypoint.refreshAll()
    },
    initFlkty () {
      let _this = this
      this.flkty = new Flickity(this.$refs.flkty, {
        cellSelector: '.o-tab__item',
        prevNextButtons: false,
        pageDots: false,
        draggable: true,
        contain: true
      })
      this.flkty.on('select', () => {
        this.currentIndex = _this.flkty.selectedIndex
        _this.setActiveTab()
      })
    },
    yesInit () {
      return (this.$store.state.windowWidth < this.elemWidth && this.device === 0)
    },
    redrawFlkty () {
      if (this.yesInit()) {
        if (this.flkty === null) {
          this.initFlkty()
        }
      } else {
        if (this.flkty !== null) {
          this.flkty.destroy()
          this.flkty = null
        }
      }
    }
  },
  created () {
    this.currentIndex = this.initialIndex
  },
  mounted () {
    this.$nextTick(() => {
      setTimeout(() => {
        this.$refs.flkty.childNodes.forEach((item) => {
          this.elemWidth += item.clientWidth
        })
        if (this.yesInit()) {
          this.initFlkty()
        }
      }, 100)
    })
    eventBus.$on('viewport-has-finished-resizing', () => {
      this.redrawFlkty()
    })

    window.addEventListener('keyup', (event) => {
      if (this.$refs.flkty === document.activeElement && this.flkty === null) {
        if (event.keyCode === 37) {
          let leftIndex = (this.currentIndex === 0) ? this.tabs.length - 1 : this.currentIndex - 1
          this.changeTab(leftIndex)
        }
        if (event.keyCode === 39) {
          let rightIndex = (this.currentIndex === this.tabs.length - 1) ? 0 : this.currentIndex + 1
          this.changeTab(rightIndex)
        }
      }
    })
  },
  watch: {
    device (val) {
      this.redrawFlkty()
    }
  }
}

export const MyTab = {
  name: 'my-tab',
  template: `
    <div :class="['o-tabs__tab', colorClass('o-tabs__tab--', tabColor)]" v-if="active"><slot></slot></div>
  `,
  data () {
    return {
      active: false
    }
  },
  props: {
    title: {
      required: true,
      type: String
    },
    tabColor: {
      required: false,
      type: String
    },
    isActive: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  methods: {
    colorClass (baseClass, color) {
      if (color) {
        return baseClass + color
      }
    }
  },
  created () {
    this.active = this.isActive
    this.$parent.addTab(this)
  }
}

export const MyTabInner = {
  name: 'my-tab-inner',
  template: `
    <div class="o-panel">
      <div class="o-panel__container">
        <slot></slot>
      </div>
    </div>
  `
}



// WEBPACK FOOTER //
// ./src/components/standard/my-tabs.js